import "./style.scss";

import ModalBox from "components/Modal";
import StyledButton from "components/shared/StyledButton";
import { useTranslation } from "react-i18next";
import { askIntegration } from "store/integrationsStore";
import { useAppDispatch } from "store/store";

interface IAskIntegrationModal {
    open: boolean;
    onClose: () => void;
    integration: string;
}
/**
 * Ask integration modal, the user can ask for an integration he's interrested by for the future.
 */
const AskIntegrationModal = ({ open, onClose, integration }: IAskIntegrationModal) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();

    const onAskForIntegration = () => {
        dispatch(askIntegration({ integrationName: integration }));
        onClose();
    };

    return (
        <ModalBox open={open} onClose={onClose} mainTitle={`${t("IntegrationsSettings.ComingSoon")} 🌟`}>
            <div className="ask-integration-modal">
                <div className="ask-integration-modal-text">
                    <div className="unvailable-info">
                        <span className="info1">{t("IntegrationsSettings.NotAvailable")}</span>
                        <span className="info2">{t("IntegrationsSettings.NotAvailableInfo")}</span>
                    </div>
                </div>
                <div className="ask-integration-modal-action-btn">
                    <StyledButton buttonType="secondary" onClick={onClose}>
                        {t("IntegrationsSettings.NoCancel")}
                    </StyledButton>
                    <StyledButton buttonType="primary" onClick={onAskForIntegration}>
                        {t("IntegrationsSettings.NotifiedWhenAvailable")}
                    </StyledButton>
                </div>
            </div>
        </ModalBox>
    );
};

export default AskIntegrationModal;
